import { Button, Grid, Typography } from '@material-ui/core'
import React, { useContext } from 'react'
import { Link, useHistory ,BrowserRouter as Router} from 'react-router-dom';
import { firebaseAuth } from './AuthProvider';
import logo from '../../images/logo.png';

function AdminHeader() {

   

    function loadPrijave(){
        history.push("/admin/pregled");
      }
  
      function loadEdit(){
        history.push("/admin/edit");
      }
  
      function loadRadovi(){
        history.push("/admin/predavaci");
      }

      function loadAdmin(){
        history.push("/admin");
      }



    const history = useHistory();
    const {token,setToken,handleSignout} = useContext(firebaseAuth)
    const handleClick = ()=>{
        handleSignout()
        history.push("/admin")

    }
    return (
            <Grid container display="row" style={{backgroundColor:"lightskyblue",paddingLeft:"50px"}}>
                <Grid item lg={4}>
                <Button onClick={loadAdmin}><img src={logo} style={{maxHeight:"50px"}}/></Button>
                </Grid>

              
           <Grid item lg={2}>
            <Button onClick={loadPrijave} style={{height:"100%",marginLeft:"50px",color:"black"}}>Pregled gostiju</Button>

            
           </Grid>
             
           <Grid item lg={2}>
           <Button onClick={loadEdit} style={{height:"100%",marginLeft:"50px",color:"black"}}>Uredi stranicu</Button>

            
           </Grid>
             
           <Grid item lg={2}>
           <Button onClick={loadRadovi} style={{height:"100%",marginLeft:"50px",color:"black"}}>Pregled predavaca</Button>

           </Grid>
           <Grid item lg={1}>
            <Button onClick={handleClick} style={{height:"100%",marginLeft:"50px",color:"black"}}>Odjava</Button>
           </Grid>

           </Grid>
         
           
       
    )
}

export default AdminHeader
